import { render, staticRenderFns } from "./forget.vue?vue&type=template&id=0c27fe80&scoped=true"
import script from "./forget.vue?vue&type=script&lang=js"
export * from "./forget.vue?vue&type=script&lang=js"
import style0 from "./forget.vue?vue&type=style&index=0&id=0c27fe80&prod&lang=scss&scoped=true"
import style1 from "./forget.vue?vue&type=style&index=1&id=0c27fe80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c27fe80",
  null
  
)

export default component.exports